import { User } from '../../../models/user.model';


export abstract class ImageGestion{
abstract cambiarImagen(file: File): void;
abstract subirImagenUsuario(usuario: User): void;
public imagenSubir: File;
public imgTemp: any = null;

}
